import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import React from "react";
import Scrollbar from "react-scrollbars-custom";
import AppBarBasic from "../../layout/AppBar";

import Copyright from "../../layout/Copyright";
import AddUserForm from "./AddUserForm";
import CardReaderForm from "./CardReaderForm";
import OfflineCardWriterForm from "./OfflineCardWriterForm";
import MasterWriterForm from "./MasterWriterForm";
import { useStyles } from "../../styles/useStyles";

const drawerWidth = 280;

export default function OfflineCards(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(true);
    const handleClick = () => {
        setOpen(!open);
    };

    const currentHost = window.location.hostname;
    const isBluestar = currentHost === "bluestar.biodit.bg";

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBarBasic />
            <main className={classes.content}>
                <Scrollbar id="RSC-Example" style={{ width: "100%", height: "100%" }}>
                    <div className={classes.appBarSpacer} />
                    <Container maxWidth="lg" className={classes.container}>
                        {(() => {
                            if (localStorage.getItem("level") === "super") {
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <OfflineCardWriterForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <MasterWriterForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <AddUserForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <CardReaderForm />
                                        </Grid>
                                    </Grid>
                                );
                            } else if (localStorage.getItem("level") === "admin") {
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <OfflineCardWriterForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <MasterWriterForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <AddUserForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <CardReaderForm />
                                        </Grid>
                                    </Grid>
                                );
                            } else if (localStorage.getItem("level") === "tech_support") {
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <OfflineCardWriterForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <MasterWriterForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <AddUserForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <CardReaderForm />
                                        </Grid>
                                    </Grid>
                                );
                            } else if (localStorage.getItem("level") === "reception") {
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <AddUserForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <OfflineCardWriterForm />
                                        </Grid>
                                        {/*<Grid item xs={12} md={6} lg={6}>*/}
                                        {/*  <MasterWriterForm />*/}
                                        {/*</Grid>*/}
                                        <Grid item xs={12} md={6} lg={6}>
                                            <CardReaderForm />
                                        </Grid>
                                    </Grid>
                                );
                            } else if (localStorage.getItem("level") === "spa") {
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <AddUserForm />
                                        </Grid>
                                        <Grid item xs={12} md={6} lg={6}>
                                            <OfflineCardWriterForm />
                                        </Grid>
                                        {/*<Grid item xs={12} md={6} lg={6}>*/}
                                        {/*  <MasterWriterForm />*/}
                                        {/*</Grid>*/}
                                        <Grid item xs={12} md={6} lg={6}>
                                            <CardReaderForm />
                                        </Grid>
                                    </Grid>
                                );
                            } else {
                            }
                        })()}
                    </Container>
                    <Copyright />
                </Scrollbar>
            </main>
        </div>
    );
}

// export default connect(
//     mapStateToProps,
//     { logoutUser }
// )(Dashboard)
